<template>
  <div class="management-bd partner-serviceArea tree-box">
    <div class="management-wrap">
      <div class="tree-list">
        <div class="search-hd">
          <el-form @submit.native.prevent>
            <el-form-item>
              <h1 class="title">{{ $t('crm_partner-serviceArea.yxcslb') }}</h1>
            </el-form-item>
            <el-form-item style="margin-right: 0">
              <el-input :placeholder="$t('crm_partner-serviceArea.qu_yu_ming_cheng')" v-model="filterSelected" clearable @input="changeSelected" style="width: 100%"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="box ub-f1">
          <el-tree ref="tree" node-key="code" :props="{ label: 'name', children: 'children' }" :data="nationRegionTree" :filter-node-method="filterCheckNode"></el-tree>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    partnerId: [String, Number],
    partnerOrgId: [String, Number],
  },
  data() {
    return {
      item: {},
      visible: false,
      filterText: '',
      filterSelected: '',
      nationRegionTree: [],
      tree: [],
      cityListSelected: [],

      // 公司ID
      companyId: '',

      // 管理员ID
      organId: '',
    };
  },
  mounted() {
    // this.companyId = this.getJump('companyId');
    this.companyId = this.partnerId || '';
    this.companyOrgId = this.partnerOrgId || '';
    this.getTreeRegionTree();
    // this.getCompanyDetail();
  },
  methods: {
    getTreeRegionTree: function () {
      this.$getJSON(apis.NationRegionTree, { level: 3, status: 1 }).then((res) => {
        this.nationRegionTree = res.data;
        this.getCompanyDetail();
      });
    },
    getCompanyDetail: function () {
      if (!this.companyOrgId) {
        return;
      }
      this.$getJSON(`${apis.serviceAreaList}/${this.companyOrgId}`).then((res) => {
        this.cityListSelected = res.data.map(i => i.cityCode);
        if (this.cityListSelected) {
          // setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.tree.filter(this.cityListSelected);
          });
          // }, 500);
        }
      });
    },

    changeSelected: function () {
      // const nodes = this.$refs.tree1.getCheckedNodes().filter(i => i.name.indexOf(this.filterSelected) !== -1);
      // this.$refs.tree2.filter(nodes);

      this.$nextTick(() => {
        this.$refs.tree.filter(this.cityListSelected);
      });
    },

    // 选中树过滤
    filterCheckNode(values, data) {
      if (this.filterSelected) {
        return values.includes(data.code) && data.name.includes(this.filterSelected);
      } else {
        return values.includes(data.code);
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.partner-serviceArea {
  .management-wrap {
    flex: 1;
    // height: 0;
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    margin: 10px;
    background-color: #ffffff;
    .morebtn {
      color: $main-color;
    }

    .title {
      font-size: 14px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      line-height: 14px;
      padding-bottom: 16px;
    }
  }
}
</style>
